import { verificationQueryKeys as e } from "./useVerificationQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { verificationApi as n } from "@maat/api-main";
//#region src/verification/useBusinessVerificationQuery.ts
var r = (r = !0) => t({
	queryKey: e.business(),
	queryFn: n.getBusinessVerification,
	enabled: r
});
//#endregion
export { r as useBusinessVerificationQuery };
